export default __webpack_public_path__ + "static/media/alyani-yang-WajET_vzPmI-unsplash2.8d741c1b.jpg";